module.exports = __webpack_public_path__ + "img/phone.85ba880a.png";